export enum MaintenanceTaskTemplateType {
  system = "system",
  equipment = "equipment",
  sms = "sms",
  audit = "audit",
}
